import { format, formatRelative, formatDistanceToNow, parseISO } from "date-fns";

export function formatDate(date: Date | string, formatStr: string = "PPP"): string {
  return format(typeof date === "string" ? parseISO(date) : date, formatStr);
}

export function formatRelativeTime(date: Date | string): string {
  return formatRelative(typeof date === "string" ? parseISO(date) : date, new Date());
}

export function formatDistance(date: Date | string): string {
  return formatDistanceToNow(typeof date === "string" ? parseISO(date) : date, { addSuffix: true });
}

export function parseDate(dateStr: string): Date | null {
  try {
    return parseISO(dateStr);
  } catch {
    return null;
  }
}

export function isToday(date: Date | string): boolean {
  const d = typeof date === "string" ? parseISO(date) : date;
  const today = new Date();
  return d.getFullYear() === today.getFullYear() &&
    d.getMonth() === today.getMonth() &&
    d.getDate() === today.getDate();
}

export function isThisWeek(date: Date | string): boolean {
  const d = typeof date === "string" ? parseISO(date) : date;
  const today = new Date();
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - today.getDay());
  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);
  return d >= startOfWeek && d <= endOfWeek;
}
